<div class="prod-page">

  <!-- ══════════════════════════════════════
       HERO
  ════════════════════════════════════════ -->
  <div class="prod-hero app-card">
    <div class="prod-hero-img-wrap">
      <img class="prod-hero-img" [src]="imageBath" [alt]="prodObj.name" />
    </div>
    <div class="prod-hero-body">
      <div class="prod-hero-meta">
        <p class="prod-eyebrow">{{ 'page.product_eyebrow' | translate }}</p>
        <div class="prod-hero-actions">
          <button class="lx-btn lx-btn--edit" (click)="addData()" data-bs-toggle="modal" data-bs-target="#editProduct">
            <span class="material-symbols-outlined">edit</span>
            {{ 'btn.edit' | translate }}
          </button>
          <button class="lx-btn lx-btn--danger" data-bs-toggle="modal" data-bs-target="#DeleteProduct">
            <span class="material-symbols-outlined">delete</span>
            {{ 'btn.delete' | translate }}
          </button>
          <button class="lx-btn" [class.lx-btn--featured]="isFeatured" [class.lx-btn--outline]="!isFeatured" (click)="toggleFeatured()">
            <span class="material-symbols-outlined">star</span>
            {{ isFeatured ? 'Product of the Week ✓' : 'Set as Product of the Week' }}
          </button>
        </div>
      </div>
      <div>
        <h1 class="prod-hero-name">{{ prodObj.name }}</h1>
        <p class="prod-hero-name-ar" *ngIf="prodObj.name_ar">{{ prodObj.name_ar }}</p>
      </div>
      <div class="prod-stats-row">
        <div class="prod-stat-pill">
          <span class="material-symbols-outlined">sell</span>
          <div>
            <p class="prod-stat-label">{{ 'lbl.price' | translate }}</p>
            <p class="prod-stat-val">{{ prodObj.price }}<span class="prod-stat-unit">LE</span></p>
          </div>
        </div>
        <div class="prod-stat-sep"></div>
        <div class="prod-stat-pill">
          <span class="material-symbols-outlined">inventory</span>
          <div>
            <p class="prod-stat-label">{{ 'lbl.in_stock' | translate }}</p>
            <p class="prod-stat-val">{{ prodObj.quantity }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ══════════════════════════════════════
       DETAILS + MEDIA GRID
  ════════════════════════════════════════ -->
  <div class="prod-body-grid">

    <!-- ── Product Details ── -->
    <div class="pd-section app-card">
      <div class="pd-section-header">
        <span class="material-symbols-outlined">description</span>
        <h3 class="pd-section-title">{{ 'prod.details' | translate }}</h3>
      </div>
      <div class="pd-section-body">
        <div class="pd-detail-block" *ngIf="description.length > 0">
          <p class="pd-detail-label">{{ 'prod.desc_en' | translate }}</p>
          <ul class="prod-desc-list">
            <li *ngFor="let item of description">{{ item }}</li>
          </ul>
        </div>
        <div class="pd-detail-block" *ngIf="prodObj.description_ar">
          <p class="pd-detail-label">{{ 'prod.desc_ar' | translate }}</p>
          <p class="pd-detail-text" dir="rtl">{{ prodObj.description_ar }}</p>
        </div>
        <div class="pd-detail-empty" *ngIf="description.length === 0 && !prodObj.description_ar">
          {{ 'empty.no_description' | translate }}
        </div>
      </div>
    </div>

    <!-- ── Product Media ── -->
    <div class="pd-section app-card">
      <div class="pd-section-header">
        <span class="material-symbols-outlined">photo_library</span>
        <h3 class="pd-section-title">{{ 'prod.media' | translate }}</h3>
      </div>
      <div class="pd-section-body">

        <div class="pd-media-group" *ngIf="mainImageArr.length > 0">
          <p class="pd-detail-label">{{ 'prod.images' | translate }}</p>
          <div class="prod-media-grid">
            <div class="prod-media-item" *ngFor="let item of mainImageArr">
              <img class="prod-media-img" [src]="item.image_url" [alt]="prodObj.name" />
              <button (click)="DeleteImage(item.id)" class="lx-btn lx-btn--danger pd-del-btn">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </div>
          </div>
        </div>

        <div class="pd-media-group" *ngIf="screenshotArray.length > 0">
          <p class="pd-detail-label">{{ 'prod.screenshots' | translate }}</p>
          <div class="prod-media-grid">
            <div class="prod-media-item" *ngFor="let item of screenshotArray">
              <img class="prod-media-img" [src]="item.image_url" alt="Screenshot" />
              <button (click)="DeleteImage(item.id)" class="lx-btn lx-btn--danger pd-del-btn">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </div>
          </div>
        </div>

        <div class="pd-media-group" *ngIf="videosArr.length > 0">
          <p class="pd-detail-label">{{ 'prod.videos' | translate }}</p>
          <div class="prod-video-grid">
            <div class="prod-video-item" *ngFor="let item of videosArr">
              <video class="prod-video" controls>
                <source [src]="item.image_url" type="video/mp4" />
                <source [src]="item.image_url" type="video/ogg" />
              </video>
              <button (click)="DeleteImage(item.id)" class="lx-btn lx-btn--danger pd-del-btn">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </div>
          </div>
        </div>

        <div class="pd-media-empty"
          *ngIf="mainImageArr.length === 0 && screenshotArray.length === 0 && videosArr.length === 0">
          <span class="material-symbols-outlined">hide_image</span>
          {{ 'empty.media' | translate }}
        </div>

      </div>
    </div>

  </div>

  <!-- ══════════════════════════════════════
       VARIANTS
  ════════════════════════════════════════ -->
  <div class="pd-section app-card">
    <div class="pd-section-header">
      <span class="material-symbols-outlined">tune</span>
      <h3 class="pd-section-title">{{ 'prod.variants' | translate }}</h3>
      <button class="lx-btn lx-btn--edit ms-auto" (click)="showAddVariant = !showAddVariant">
        <span class="material-symbols-outlined">add</span>
        {{ 'btn.add_variant' | translate }}
      </button>
    </div>

    <div class="pd-add-variant" *ngIf="showAddVariant">
      <div class="pd-variant-fields">
        <div class="lx-field-group">
          <label class="lx-field-label">{{ 'lbl.name' | translate }}</label>
          <input class="lx-input" [(ngModel)]="newVariant.name" placeholder="e.g. Color" />
        </div>
        <div class="lx-field-group">
          <label class="lx-field-label">{{ 'lbl.value' | translate }}</label>
          <input class="lx-input" [(ngModel)]="newVariant.value" placeholder="e.g. Red" />
        </div>
        <div class="lx-field-group">
          <label class="lx-field-label">{{ 'lbl.price_modifier' | translate }}</label>
          <input class="lx-input" type="number" [(ngModel)]="newVariant.price_modifier" />
        </div>
        <div class="lx-field-group">
          <label class="lx-field-label">{{ 'lbl.quantity' | translate }}</label>
          <input class="lx-input" type="number" [(ngModel)]="newVariant.quantity" />
        </div>
        <div class="lx-field-group">
          <label class="lx-field-label">{{ 'lbl.sku' | translate }}</label>
          <input class="lx-input" [(ngModel)]="newVariant.sku" placeholder="Optional" />
        </div>
      </div>
      <div class="pd-variant-footer">
        <button class="lx-btn lx-btn--primary" (click)="saveNewVariant()">
          <span class="material-symbols-outlined">check</span>
          {{ 'btn.save_variant' | translate }}
        </button>
        <button class="lx-btn lx-btn--ghost" (click)="showAddVariant = false">{{ 'btn.cancel' | translate }}</button>
      </div>
    </div>

    <div class="pd-empty-inline" *ngIf="variants.length === 0 && !showAddVariant">
      <span class="material-symbols-outlined">tune</span>
      {{ 'empty.variants' | translate }}
    </div>

    <div class="lx-table-wrap" *ngIf="variants.length > 0">
      <table class="lx-table">
        <thead>
          <tr>
            <th>{{ 'lbl.name' | translate }}</th>
            <th>{{ 'lbl.value' | translate }}</th>
            <th>{{ 'lbl.price_modifier' | translate }}</th>
            <th>{{ 'lbl.quantity' | translate }}</th>
            <th>{{ 'lbl.sku' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let v of variants">
            <ng-container *ngIf="editingVariant?.id !== v.id">
              <td>{{ v.name }}</td>
              <td>{{ v.value }}</td>
              <td>{{ v.price_modifier }} LE</td>
              <td>{{ v.quantity }}</td>
              <td><span class="pd-sku">{{ v.sku || '—' }}</span></td>
              <td class="pd-actions-cell">
                <button class="lx-icon-btn" (click)="startEditVariant(v)">
                  <span class="material-symbols-outlined">edit</span>
                </button>
                <button class="lx-icon-btn lx-icon-btn--danger" (click)="deleteVariant(v.id)">
                  <span class="material-symbols-outlined">delete</span>
                </button>
              </td>
            </ng-container>
            <ng-container *ngIf="editingVariant?.id === v.id">
              <td><input class="lx-input pd-inline-input" [(ngModel)]="editingVariant.name" /></td>
              <td><input class="lx-input pd-inline-input" [(ngModel)]="editingVariant.value" /></td>
              <td><input class="lx-input pd-inline-input" type="number" [(ngModel)]="editingVariant.price_modifier" /></td>
              <td><input class="lx-input pd-inline-input" type="number" [(ngModel)]="editingVariant.quantity" /></td>
              <td><input class="lx-input pd-inline-input" [(ngModel)]="editingVariant.sku" /></td>
              <td class="pd-actions-cell">
                <button class="lx-icon-btn" (click)="saveEditVariant()">
                  <span class="material-symbols-outlined">check</span>
                </button>
                <button class="lx-icon-btn lx-icon-btn--danger" (click)="editingVariant = null">
                  <span class="material-symbols-outlined">close</span>
                </button>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ══════════════════════════════════════
       REVIEWS
  ════════════════════════════════════════ -->
  <div class="pd-section app-card">
    <div class="pd-section-header">
      <span class="material-symbols-outlined">reviews</span>
      <h3 class="pd-section-title">{{ 'prod.reviews' | translate }}</h3>
    </div>

    <div class="pd-empty-inline" *ngIf="reviews.length === 0">
      <span class="material-symbols-outlined">rate_review</span>
      {{ 'empty.reviews' | translate }}
    </div>

    <div class="lx-table-wrap" *ngIf="reviews.length > 0">
      <table class="lx-table">
        <thead>
          <tr>
            <th>{{ 'lbl.client' | translate }}</th>
            <th>{{ 'lbl.rating' | translate }}</th>
            <th>{{ 'lbl.review' | translate }}</th>
            <th>{{ 'lbl.approved' | translate }}</th>
            <th>{{ 'lbl.visible' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of reviews">
            <td>{{ r.client?.first_name }} {{ r.client?.last_name }}</td>
            <td>{{ r.rating }} / 5</td>
            <td>{{ r.review }}</td>
            <td>
              <button class="lx-btn lx-btn--sm"
                [class.lx-btn--success]="r.is_approved"
                [class.lx-btn--ghost]="!r.is_approved"
                (click)="moderateReview(r, 'is_approved', !r.is_approved)">
                {{ (r.is_approved ? 'status.approved' : 'status.approve') | translate }}
              </button>
            </td>
            <td>
              <button class="lx-btn lx-btn--sm"
                [class.lx-btn--success]="r.is_visible"
                [class.lx-btn--ghost]="!r.is_visible"
                (click)="moderateReview(r, 'is_visible', !r.is_visible)">
                {{ (r.is_visible ? 'status.visible' : 'status.hidden') | translate }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>

<!-- ══════════════════════════════════════
     Edit Product Modal
════════════════════════════════════════ -->
<div class="modal fade" id="editProduct" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content lx-modal-content">
      <div class="lx-modal-header lx-modal-header--row">
        <div>
          <p class="lx-modal-eyebrow">{{ 'page.product_eyebrow' | translate }}</p>
          <h5 class="lx-modal-title">{{ 'prod.edit_title' | translate }}</h5>
        </div>
        <button type="button" class="lx-modal-close" data-bs-dismiss="modal">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="lx-modal-body">
        <form [formGroup]="productForm">
          <div class="pd-modal-field-row">
            <div class="lx-field-group">
              <label class="lx-field-label">{{ 'prod.name_en' | translate }}</label>
              <input formControlName="name" type="text" class="lx-input" [placeholder]="'ph.product_name' | translate" />
            </div>
            <div class="lx-field-group">
              <label class="lx-field-label">{{ 'prod.name_ar_label' | translate }}</label>
              <input formControlName="name_ar" type="text" class="lx-input" placeholder="اسم المنتج" dir="rtl" />
            </div>
          </div>
          <div class="pd-modal-field-row">
            <div class="lx-field-group">
              <label class="lx-field-label">{{ 'lbl.price' | translate }}</label>
              <input formControlName="price" type="number" min="0" class="lx-input" [placeholder]="'ph.price' | translate" />
            </div>
            <div class="lx-field-group">
              <label class="lx-field-label">Discount (%)</label>
              <input formControlName="discount" type="number" min="0" max="100" class="lx-input" placeholder="0" />
            </div>
          </div>
          <div class="pd-modal-field-row">
            <div class="lx-field-group">
              <label class="lx-field-label">{{ 'lbl.quantity' | translate }}</label>
              <input formControlName="quantity" type="number" min="0" class="lx-input" [placeholder]="'ph.quantity' | translate" />
            </div>
          </div>
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'prod.desc_en' | translate }}</label>
            <textarea formControlName="description" class="lx-input lx-textarea" [placeholder]="'ph.description' | translate"></textarea>
          </div>
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'prod.desc_ar' | translate }}</label>
            <textarea formControlName="description_ar" class="lx-input lx-textarea" placeholder="وصف المنتج..." dir="rtl"></textarea>
          </div>
        </form>
        <div class="lx-field-group">
          <label class="lx-field-label">{{ 'prod.add_images' | translate }}</label>
          <input multiple accept="image/*" (change)="uploadFile($event, 'main')" type="file" class="lx-input lx-file-input" />
        </div>
        <div class="lx-field-group">
          <label class="lx-field-label">{{ 'prod.add_screenshots' | translate }}</label>
          <input multiple accept="image/*" (change)="uploadFile($event, 'screenshot')" type="file" class="lx-input lx-file-input" />
        </div>
        <div class="lx-field-group">
          <label class="lx-field-label">{{ 'prod.add_video' | translate }}</label>
          <input multiple accept="video/*" (change)="uploadFile($event, 'video')" type="file" class="lx-input lx-file-input" />
        </div>
      </div>
      <div class="lx-modal-footer">
        <button type="button" class="lx-btn lx-btn--ghost" data-bs-dismiss="modal">{{ 'btn.cancel' | translate }}</button>
        <button (click)="editProduct()" type="button" class="lx-btn lx-btn--primary" data-bs-dismiss="modal">
          <span class="material-symbols-outlined">save</span>
          {{ 'btn.save_changes' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ══════════════════════════════════════
     Delete Product Modal
════════════════════════════════════════ -->
<div class="modal fade" id="DeleteProduct" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content lx-modal-content">
      <div class="lx-modal-header lx-modal-header--centered">
        <div class="lx-modal-icon lx-modal-icon--danger">
          <span class="material-symbols-outlined">delete_forever</span>
        </div>
        <h5 class="lx-modal-title">{{ 'confirm.delete_product' | translate }}</h5>
        <p class="lx-modal-subtitle">
          {{ 'confirm.are_you_sure_delete' | translate }} <strong>{{ prodObj.name }}</strong>?
          {{ 'confirm.cannot_undo' | translate }}
        </p>
      </div>
      <div class="lx-modal-footer lx-modal-footer--centered">
        <button type="button" class="lx-btn lx-btn--ghost" data-bs-dismiss="modal">{{ 'btn.cancel' | translate }}</button>
        <button (click)="deleteProduct()" type="button" data-bs-dismiss="modal" class="lx-btn lx-btn--danger">
          <span class="material-symbols-outlined">delete</span>
          {{ 'btn.delete' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
